<div class="form-group row">
  <div class="form-content">
    <div>
      <div class="header">HTML</div>
      <ngx-codemirror
        id="codemirror-1"
        [(ngModel)]="modelHtmlData"
        (ngModelChange)="onModelChange()"
        [options]="{
          lineNumbers: this.lineNumbers,
          theme: 'material',
          mode: 'htmlmixed',
          indentUnit: 2,
          readOnly: !editMode,
        }"></ngx-codemirror>
    </div>
    <div>
      <div class="header">Javascript</div>
      <ngx-codemirror
        id="codemirror-2"
        [(ngModel)]="modelJsData"
        (ngModelChange)="onModelChange()"
        [options]="{
          lineNumbers: this.lineNumbers,
          theme: 'oceanic-next',
          mode: 'javascript',
          indentUnit: 2,
          readOnly: !editMode,
        }"></ngx-codemirror>
    </div>
    <div>
      <div class="header">Css</div>
      <ngx-codemirror
        id="codemirror-3"
        [(ngModel)]="modelCssData"
        (ngModelChange)="onModelChange()"
        [options]="{
          lineNumbers: this.lineNumbers,
          theme: 'lesser-dark',
          mode: 'css',
          indentUnit: 2,
          readOnly: !editMode,
        }"></ngx-codemirror>
    </div>
    <div>
      <div class="header">Data</div>
      <ngx-codemirror
        id="codemirror-4"
        [(ngModel)]="modelDataData"
        (ngModelChange)="onModelChange()"
        [options]="{
          lineNumbers: this.lineNumbers,
          theme: 'pastel-on-dark',
          mode: 'json',
          indentUnit: 2,
          readOnly: !editMode,
        }"></ngx-codemirror>
    </div>
  </div>
</div>
